import {
  SHOP_EDIT, SHOP_EDIT_FAILURE, SHOP_EDIT_SUCCESS, SHOP_UPDATE, SHOP_UPDATE_FAILURE, SHOP_UPDATE_SUCCESS
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    shop: null,
    shopNotify: null
  },
  getters: {
    shopEditNotify: state => {
      return state.shopNotify
    },
    shopEditDetail: state => {
      return state.shop
    }
  },
  actions: {
    [SHOP_EDIT] ({dispatch, state, commit}, params = null) {
      var url = '/master/shops/' + params.id + '/edit'
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_EDIT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(SHOP_EDIT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHOP_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/shops/' + params.shop_id, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_UPDATE_FAILURE, res.data)
          } else {
            commit(SHOP_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_EDIT_FAILURE] (state, data) {
      console.log('SHOP_EDIT_FAILURE')
    },
    [SHOP_EDIT_SUCCESS] (state, data) {
      console.log('SHOP_EDIT_SUCCESS')
      state.shop = data.data
      data.callback()
      state.loading = false
    },
    [SHOP_UPDATE_FAILURE] (state, data) {
      console.log('SHOP_UPDATE_FAILURE')
      state.shopNotify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.shopNotify = null
      }, constant.notifyShowTime.long)
    },
    [SHOP_UPDATE_SUCCESS] (state, data) {
      console.log('SHOP_UPDATE_SUCCESS')
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-edit.js